(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.header', [
    'pp.widgets.header-nav-mobile',
    'pp.widgets.resources-dropdown',
    'pp.widgets.auth-nav',
    'pp.widgets.auth-modal'
]);
})(window, window.angular);